class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.header.classList.add('mega-menu-open');
      document.documentElement.classList.add('mega-menu-open');
    } else if (!this.header.querySelector('header-menu details[open]')) {
      this.header.classList.remove('mega-menu-open');
      document.documentElement.classList.remove('mega-menu-open');
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// PC 端导航二级菜单由点击改为悬停展开
(function () {
  const desktopMediaQuery = window.matchMedia('(min-width: 990px)');
  let isDesktop = desktopMediaQuery.matches;
  const closeTimers = new WeakMap();

  function setOpen(headerMenu, open) {
    const details = headerMenu.querySelector('details');
    if (!details) return;

    if (open) {
      // 强制重绘，确保浏览器重新计算关闭状态，
      // 这样再次打开时 transition 能从初始状态正常播放到展开状态
      const content = details.querySelector('.mega-menu__content, .single_menu_content');
      if (content) {
        void content.offsetHeight;
      }
      details.open = true;
      if (content) {
        void content.offsetHeight;
      }
    } else {
      details.open = false;
    }
  }

  function closeAllHeaderMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      setOpen(menu, false);
    });
  }

  function clearTimer(menu) {
    if (closeTimers.has(menu)) {
      clearTimeout(closeTimers.get(menu));
      closeTimers.delete(menu);
    }
  }

  function scheduleClose(menu) {
    clearTimer(menu);
    const timer = setTimeout(() => {
      if (!menu.matches(':hover')) {
        setOpen(menu, false);
      }
      closeTimers.delete(menu);
    }, 150);
    closeTimers.set(menu, timer);
  }

  function updateHoverState(enabled) {
    document.querySelectorAll('header-menu').forEach((menu) => {
      const details = menu.querySelector('details');
      if (!details) return;

      const content = details.querySelector('.mega-menu__content, .header__submenu');

      if (enabled) {
        menu.addEventListener('mouseenter', handleMenuMouseEnter);
        menu.addEventListener('mouseleave', handleMenuMouseLeave);
        if (content) {
          content.addEventListener('mouseenter', handleContentMouseEnter);
          content.addEventListener('mouseleave', handleContentMouseLeave);
        }
      } else {
        menu.removeEventListener('mouseenter', handleMenuMouseEnter);
        menu.removeEventListener('mouseleave', handleMenuMouseLeave);
        if (content) {
          content.removeEventListener('mouseenter', handleContentMouseEnter);
          content.removeEventListener('mouseleave', handleContentMouseLeave);
        }
        clearTimer(menu);
        setOpen(menu, false);
      }
    });
  }

  function handleMenuMouseEnter(event) {
    if (!isDesktop) return;
    const menu = event.currentTarget;
    clearTimer(menu);
    document.querySelectorAll('header-menu').forEach((otherMenu) => {
      if (otherMenu !== menu) {
        clearTimer(otherMenu);
        setOpen(otherMenu, false);
      }
    });
    setOpen(menu, true);
  }

  function handleMenuMouseLeave(event) {
    if (!isDesktop) return;
    const menu = event.currentTarget;
    // 鼠标移向二级菜单（绝对定位的 content）时，浏览器可能会先触发 header-menu 的 mouseleave。
    // 通过 elementFromPoint 判断鼠标是否仍在菜单内容上方，避免误关闭。
    const hoveredElement = document.elementFromPoint(event.clientX, event.clientY);
    if (hoveredElement && menu.contains(hoveredElement)) {
      return;
    }
    scheduleClose(menu);
  }

  function handleContentMouseEnter(event) {
    if (!isDesktop) return;
    const content = event.currentTarget;
    const menu = content.closest('header-menu');
    if (!menu) return;
    clearTimer(menu);
    setOpen(menu, true);
  }

  function handleContentMouseLeave(event) {
    if (!isDesktop) return;
    const content = event.currentTarget;
    const menu = content.closest('header-menu');
    if (!menu) return;
    scheduleClose(menu);
  }

  function handleMaskMouseEnter(event) {
    if (!isDesktop) return;
    const mask = event.currentTarget;
    const details = mask.closest('details');
    if (details) {
      details.open = false;
    }
  }

  if (isDesktop) {
    updateHoverState(true);
  }

  // PC 端鼠标滑入导航区域（header__inline-menu）时，首页透明头部切换为实底背景
  const headerWrapper = document.querySelector('.header-wrapper');
  const inlineMenu = document.querySelector('.header__inline-menu');

  if (headerWrapper && inlineMenu) {
    inlineMenu.addEventListener('mouseenter', () => {
      if (!isDesktop) return;
      headerWrapper.classList.add('header-wrapper--menu-hover');
    });
    inlineMenu.addEventListener('mouseleave', () => {
      if (!isDesktop) return;
      headerWrapper.classList.remove('header-wrapper--menu-hover');
    });
  }

  document.querySelectorAll('.mask').forEach((mask) => {
    mask.addEventListener('mouseenter', handleMaskMouseEnter);
  });

  desktopMediaQuery.addEventListener('change', (event) => {
    isDesktop = event.matches;
    if (isDesktop) {
      updateHoverState(true);
    } else {
      updateHoverState(false);
      closeAllHeaderMenus();
      headerWrapper?.classList.remove('header-wrapper--menu-hover');
    }
  });
})();
